
import { Shift, ShiftInput } from '../types';
import { supabase } from '../supabaseClient';

export type Tier =
  | 'FERRO'
  | 'BRONZE'
  | 'PRATA'
  | 'OURO'
  | 'RODIO'
  | 'PLATINA'
  | 'TITANIO'
  | 'ESMERALDA'
  | 'RUBI'
  | 'SAFIRA'
  | 'DIAMANTE'
  | 'OBSIDIANA'
  | 'GRAFENO'
  | 'ACO_VALIRIANO'
  | 'VIBRANIUM'
  | 'ORICALCO'
  | 'ADAMANTINO'
  | 'ETER'
  | 'MATERIA_ESCURA'
  | 'NEBULA'
  | 'SUPERNOVA'
  | 'SINGULARIDADE';

export const XP_VALUES = {
  // Turnos (já existentes)
  SHIFT_WORK: 20,
  SHIFT_EXTRA: 10,
  SHIFT_OFF: 10,
  SHIFT_EXPENSE: 5,
  PENALTY_NO_SHOW: -100,
  // Marketplace
  AD_CREATED: 50,
  AD_SOLD: 30,
  // Mapa/Frota
  LOCATION_APPROVED: 40,
  // Perfil
  PROFILE_PHOTO: 30,
  PROFILE_PHONE: 20,
  PROFILE_NICKNAME: 10,
  ALARM_ENABLED: 15,
  ALARM_SOUND_SELECTED: 10,
  FAVORITE_CAR: 10,
  // Outros (já existentes)
  REFERRAL: 250,
  FEATURE_USAGE: 10,
  MONTHLY_GOAL: 100,
};

export interface TierConfig {
  key: Tier;
  label: string;
  min_score: number;
  max_score: number;
  categoria: string;
  color: string;
  border: string;
  shadow: string;
  gradient: string;
  icon: string;
  labelBg: string;
}

export const TIERS_CONFIG: TierConfig[] = [
  {
    key: 'FERRO',
    label: 'Ferro',
    min_score: 0,
    max_score: 999,
    categoria: 'Base',
    color: 'text-slate-500',
    border: 'border-slate-500',
    shadow: 'shadow-none',
    gradient: 'from-slate-500 to-slate-700',
    icon: '🔩',
    labelBg: 'bg-slate-500'
  },
  {
    key: 'BRONZE',
    label: 'Bronze',
    min_score: 1000,
    max_score: 2499,
    categoria: 'Base',
    color: 'text-amber-700',
    border: 'border-amber-700',
    shadow: 'shadow-amber-900/30',
    gradient: 'from-amber-600 to-amber-800',
    icon: '🛡️',
    labelBg: 'bg-amber-700'
  },
  {
    key: 'PRATA',
    label: 'Prata',
    min_score: 2500,
    max_score: 4999,
    categoria: 'Base',
    color: 'text-slate-300',
    border: 'border-slate-300',
    shadow: 'shadow-slate-400/30',
    gradient: 'from-slate-300 to-slate-500',
    icon: '⚔️',
    labelBg: 'bg-slate-500'
  },
  {
    key: 'OURO',
    label: 'Ouro',
    min_score: 5000,
    max_score: 9999,
    categoria: 'Base',
    color: 'text-yellow-400',
    border: 'border-yellow-400',
    shadow: 'shadow-yellow-500/50 shadow-lg',
    gradient: 'from-yellow-400 to-amber-600',
    icon: '👑',
    labelBg: 'bg-yellow-500'
  },
  {
    key: 'RODIO',
    label: 'Ródio',
    min_score: 10000,
    max_score: 14999,
    categoria: 'Metais Nobres',
    color: 'text-slate-400',
    border: 'border-slate-400',
    shadow: 'shadow-slate-500/30',
    gradient: 'from-slate-400 to-zinc-600',
    icon: '✨',
    labelBg: 'bg-slate-500'
  },
  {
    key: 'PLATINA',
    label: 'Platina',
    min_score: 15000,
    max_score: 19999,
    categoria: 'Metais Nobres',
    color: 'text-cyan-400',
    border: 'border-cyan-400',
    shadow: 'shadow-[0_0_15px_rgba(34,211,238,0.6)] shadow-lg',
    gradient: 'from-cyan-400 to-blue-600',
    icon: '💎',
    labelBg: 'bg-cyan-500'
  },
  {
    key: 'TITANIO',
    label: 'Titânio',
    min_score: 20000,
    max_score: 25999,
    categoria: 'Metais Nobres',
    color: 'text-zinc-300',
    border: 'border-zinc-400',
    shadow: 'shadow-zinc-500/40',
    gradient: 'from-zinc-500 to-neutral-700',
    icon: '🔩',
    labelBg: 'bg-zinc-600'
  },
  {
    key: 'ESMERALDA',
    label: 'Esmeralda',
    min_score: 26000,
    max_score: 33999,
    categoria: 'Pedras Preciosas',
    color: 'text-emerald-400',
    border: 'border-emerald-400',
    shadow: 'shadow-[0_0_12px_rgba(52,211,153,0.5)]',
    gradient: 'from-emerald-400 to-teal-600',
    icon: '💚',
    labelBg: 'bg-emerald-500'
  },
  {
    key: 'RUBI',
    label: 'Rubi',
    min_score: 34000,
    max_score: 43999,
    categoria: 'Pedras Preciosas',
    color: 'text-rose-400',
    border: 'border-rose-500',
    shadow: 'shadow-[0_0_12px_rgba(244,63,94,0.5)]',
    gradient: 'from-rose-500 to-red-700',
    icon: '❤️',
    labelBg: 'bg-rose-600'
  },
  {
    key: 'SAFIRA',
    label: 'Safira',
    min_score: 44000,
    max_score: 55999,
    categoria: 'Pedras Preciosas',
    color: 'text-blue-400',
    border: 'border-blue-500',
    shadow: 'shadow-[0_0_12px_rgba(59,130,246,0.5)]',
    gradient: 'from-blue-500 to-indigo-700',
    icon: '🔮',
    labelBg: 'bg-blue-600'
  },
  {
    key: 'DIAMANTE',
    label: 'Diamante',
    min_score: 56000,
    max_score: 69999,
    categoria: 'Pedras Preciosas',
    color: 'text-sky-300',
    border: 'border-sky-300',
    shadow: 'shadow-[0_0_20px_rgba(125,211,252,0.8)]',
    gradient: 'from-sky-300 to-sky-500',
    icon: '💎',
    labelBg: 'bg-sky-400'
  },
  {
    key: 'OBSIDIANA',
    label: 'Obsidiana',
    min_score: 70000,
    max_score: 89999,
    categoria: 'Tech Black',
    color: 'text-neutral-400',
    border: 'border-neutral-700',
    shadow: 'shadow-black/70 shadow-lg',
    gradient: 'from-neutral-800 to-neutral-950',
    icon: '🌑',
    labelBg: 'bg-neutral-800'
  },
  {
    key: 'GRAFENO',
    label: 'Grafeno',
    min_score: 90000,
    max_score: 114999,
    categoria: 'Tech Black',
    color: 'text-slate-300',
    border: 'border-slate-500',
    shadow: 'shadow-slate-700/50 shadow-md',
    gradient: 'from-slate-700 to-zinc-900',
    icon: '⚡',
    labelBg: 'bg-slate-700'
  },
  {
    key: 'ACO_VALIRIANO',
    label: 'Aço Valiriano',
    min_score: 115000,
    max_score: 149999,
    categoria: 'Cultura Pop',
    color: 'text-stone-300',
    border: 'border-stone-400',
    shadow: 'shadow-stone-600/50',
    gradient: 'from-stone-400 to-stone-700',
    icon: '🗡️',
    labelBg: 'bg-stone-600'
  },
  {
    key: 'VIBRANIUM',
    label: 'Vibranium',
    min_score: 150000,
    max_score: 199999,
    categoria: 'Cultura Pop',
    color: 'text-fuchsia-400',
    border: 'border-fuchsia-500',
    shadow: 'shadow-[0_0_15px_rgba(217,70,239,0.6)]',
    gradient: 'from-fuchsia-600 to-indigo-900',
    icon: '🟣',
    labelBg: 'bg-fuchsia-600'
  },
  {
    key: 'ORICALCO',
    label: 'Oricalco',
    min_score: 200000,
    max_score: 259999,
    categoria: 'Lendas Mitológicas',
    color: 'text-orange-400',
    border: 'border-orange-500',
    shadow: 'shadow-orange-500/50 shadow-md',
    gradient: 'from-orange-400 to-red-600',
    icon: '🔱',
    labelBg: 'bg-orange-500'
  },
  {
    key: 'ADAMANTINO',
    label: 'Adamantino',
    min_score: 260000,
    max_score: 339999,
    categoria: 'Lendas Mitológicas',
    color: 'text-violet-300',
    border: 'border-violet-400',
    shadow: 'shadow-[0_0_15px_rgba(139,92,246,0.6)]',
    gradient: 'from-violet-500 to-fuchsia-700',
    icon: '⚔️',
    labelBg: 'bg-violet-600'
  },
  {
    key: 'ETER',
    label: 'Éter',
    min_score: 340000,
    max_score: 449999,
    categoria: 'Lendas Mitológicas',
    color: 'text-purple-300',
    border: 'border-purple-300',
    shadow: 'shadow-[0_0_20px_rgba(192,132,252,0.8)] animate-pulse',
    gradient: 'from-indigo-400 via-purple-400 to-pink-400',
    icon: '✨',
    labelBg: 'bg-purple-500'
  },
  {
    key: 'MATERIA_ESCURA',
    label: 'Matéria Escura',
    min_score: 450000,
    max_score: 599999,
    categoria: 'Cosmos',
    color: 'text-purple-500',
    border: 'border-purple-900',
    shadow: 'shadow-[0_0_25px_rgba(126,34,206,0.5)] animate-pulse',
    gradient: 'from-purple-950 via-slate-900 to-black',
    icon: '🕳️',
    labelBg: 'bg-purple-950'
  },
  {
    key: 'NEBULA',
    label: 'Nébula',
    min_score: 600000,
    max_score: 799999,
    categoria: 'Cosmos',
    color: 'text-pink-400',
    border: 'border-pink-400',
    shadow: 'shadow-[0_0_25px_rgba(244,114,182,0.7)] animate-pulse',
    gradient: 'from-pink-500 via-purple-600 to-indigo-700',
    icon: '🌌',
    labelBg: 'bg-pink-500'
  },
  {
    key: 'SUPERNOVA',
    label: 'Supernova',
    min_score: 800000,
    max_score: 999999,
    categoria: 'Cosmos',
    color: 'text-amber-400',
    border: 'border-amber-300',
    shadow: 'shadow-[0_0_30px_rgba(245,158,11,0.9)] animate-pulse',
    gradient: 'from-amber-400 via-orange-500 to-red-600',
    icon: '💥',
    labelBg: 'bg-amber-500'
  },
  {
    key: 'SINGULARIDADE',
    label: 'Singularidade',
    min_score: 1000000,
    max_score: 999999999,
    categoria: 'Deus do App',
    color: 'text-cyan-400 font-black animate-pulse',
    border: 'border-cyan-300',
    shadow: 'shadow-[0_0_35px_rgba(34,211,238,0.9)] shadow-cyan-400/50 animate-pulse',
    gradient: 'from-cyan-400 via-fuchsia-500 to-yellow-300',
    icon: '🌀',
    labelBg: 'bg-gradient-to-r from-cyan-500 to-fuchsia-500'
  }
];

export const getTier = (xp: number): Tier => {
  const tier = TIERS_CONFIG.find(t => xp >= t.min_score && xp <= t.max_score);
  return tier ? tier.key : 'FERRO';
};

export const getTierDetails = (tier: Tier): TierConfig => {
  const config = TIERS_CONFIG.find(t => t.key === tier);
  if (config) return config;
  
  return {
    key: 'FERRO',
    label: 'Ferro',
    min_score: 0,
    max_score: 999,
    categoria: 'Base',
    color: 'text-slate-500',
    border: 'border-slate-500',
    shadow: 'shadow-none',
    gradient: 'from-slate-500 to-slate-700',
    icon: '🔩',
    labelBg: 'bg-slate-500'
  };
};

export const getPrevTierXP = (currentXP: number): number => {
  const tier = getTier(currentXP);
  const config = TIERS_CONFIG.find(t => t.key === tier);
  return config ? config.min_score : 0;
};

export const getNextTierXP = (currentXP: number): number => {
  const currentTier = getTier(currentXP);
  const currentIndex = TIERS_CONFIG.findIndex(t => t.key === currentTier);
  if (currentIndex !== -1 && currentIndex < TIERS_CONFIG.length - 1) {
    return TIERS_CONFIG[currentIndex + 1].min_score;
  }
  return currentXP * 1.5;
};

// --- DATABASE UPDATE FUNCTIONS ---

/**
 * Core function to read current XP, add amount, and save back to DB.
 * Now also records the action in gamification_logs for ranking filters.
 */
export const addXpToProfile = async (userId: string, amount: number, category: string = 'OTHER') => {
  try {
    // 1. Record log for ranking (New!)
    const { error: logError } = await supabase
      .from('gamification_logs')
      .insert({
        user_id: userId,
        amount: amount,
        category: category
      });

    if (logError) {
      console.error("Error creating gamification log:", logError);
    }

    // 2. Use RPC function for atomic increment of total XP
    const { error } = await supabase.rpc('increment_xp', {
      p_user_id: userId,
      p_amount: amount
    });

    if (error) {
      console.error("Error updating XP via RPC:", error);
      return;
    }

    console.log(`Gamification: Added ${amount} XP (${category}) to user ${userId}.`);

  } catch (error) {
    console.error("Failed to update XP:", error);
  }
};

/**
 * Awards XP to a user based on their email address (useful for Map/Fleet approvals).
 */
export const rewardUserByEmail = async (email: string, amount: number, category: string = 'MAP_CONTRIBUTION') => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('id')
      .eq('email', email)
      .single();
      
    if (error || !data) {
      console.error(`Could not find user with email ${email} to reward XP.`);
      return;
    }
    
    await addXpToProfile(data.id, amount, category);
  } catch (error) {
    console.error("Failed in rewardUserByEmail:", error);
  }
};

/**
 * Awards XP only once per action key (stored in localStorage).
 * Prevents duplicate rewards for one-time profile completions.
 */
export const awardOnce = async (userId: string, key: string, amount: number): Promise<boolean> => {
  const storageKey = `xp_awarded_${userId}_${key}`;
  if (localStorage.getItem(storageKey)) return false; // already awarded
  localStorage.setItem(storageKey, '1');
  
  // Map key to category
  let category = 'PROFILE';
  if (key.includes('alarm')) category = 'PROFILE';
  
  await addXpToProfile(userId, amount, category);
  console.log(`Gamification: Awarded ${amount} XP once for [${key}]`);
  return true;
};

/**
 * Tracks usage of specific features to award XP (throttled).
 */
export const trackFeatureUsage = async (userId: string, featureName: string) => {
  console.log(`Tracking usage for ${featureName}`);
  await addXpToProfile(userId, XP_VALUES.FEATURE_USAGE, 'FEATURE_USAGE');
};

/**
 * Awards XP for a successful referral.
 */
export const trackReferral = async (userId: string) => {
  console.log("Tracking referral");
  await addXpToProfile(userId, XP_VALUES.REFERRAL, 'REFERRAL');
};

/**
 * Calculates XP change based on Shift input and updates the user profile in DB.
 */
export const processShiftGamification = async (userId: string, shift: Shift | ShiftInput) => {
  let xpToAdd = 0;

  // 1. Base Shift Type Logic
  if (shift.type === 'WORK') {
    xpToAdd += XP_VALUES.SHIFT_WORK;
  } else if (shift.type === 'OFF') {
    xpToAdd += XP_VALUES.SHIFT_OFF;
  } else if (shift.type === 'NO_SHOW') {
    xpToAdd += XP_VALUES.PENALTY_NO_SHOW;
  }

  // 2. Extra Earnings
  if (shift.extraEarnings && shift.extraEarnings.length > 0) {
    xpToAdd += XP_VALUES.SHIFT_EXTRA;
  }

  // 3. Expenses
  if (shift.expenses && shift.expenses.length > 0) {
    xpToAdd += XP_VALUES.SHIFT_EXPENSE;
  }

  if (xpToAdd === 0) return;

  await addXpToProfile(userId, xpToAdd, 'SHIFT');
};


/**
 * Legacy client-side calculation (kept for fallback or initialization)
 */
export const calculateTotalXP = (shifts: Shift[]): number => {
  let xp = 0;
  shifts.forEach(s => {
    if (s.type === 'WORK') xp += XP_VALUES.SHIFT_WORK;
    if (s.type === 'OFF') xp += XP_VALUES.SHIFT_OFF;
    if (s.type === 'NO_SHOW' || s.noShow) xp += XP_VALUES.PENALTY_NO_SHOW;
  });
  return Math.max(0, xp);
};
